'use strict';

const severityMapper = require('./severityMapper');

const emptyFn = function () {
  // Just an empty function to fallback into
}

function isInternalLog() {
  for (let i = 0; i < arguments.length; i++) {
    if (arguments[i] === '_sd-logger') {
      return true;
    }
  }
  return false;
}

module.exports = (loggingClient) => {

  console.internal = function () {
    if (!loggingClient.options || !loggingClient.options.debug) {
      return;
    }
    const args = (arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments));
    args.push('_sd-logger');
    console.log(...args);
  }

  const proxyLog = (consoleMethod, severity) => {
    if (typeof consoleMethod !== "function") {
      throw "Proxy log only accepts functions as console method";
    }
    return function () {
      consoleMethod(...arguments);
      if (!isInternalLog(...arguments)) {
        loggingClient.log(severity, arguments);
      }
    }
  }

  console.log = proxyLog(console.log, severityMapper.levels.info);
  console.info = proxyLog(console.info, severityMapper.levels.info);
  console.warn = proxyLog(console.warn, severityMapper.levels.warning);
  console.error = proxyLog(console.error, severityMapper.levels.error);


  if (!loggingClient.options.reportUncaughtExceptions) {
    return;
  }

  try {
    window.addEventListener('unhandledrejection', function (e) {
      if (e.reason) {
        let msg = 'Uncaught promise: '

        try {
          msg += (typeof e.reason === 'string' ? e.reason : JSON.stringify(e.reason));
        } catch (e) {
          msg += e.reason.message || 'unknown error'
        }

        loggingClient.log('error', [msg]);
      }
    });

    window.addEventListener('error', function (e) {
      if (e) {
        loggingClient.log('error', [('Window error: ' + e.message) || 'Uncaught exception']);
      }
    });

  } catch (e) {
    console.internal('Failed to attach onerror handler: ', e.message);
  }
};
